import { render, staticRenderFns } from "./PerformanceList.vue?vue&type=template&id=28b18b60&scoped=true&"
import script from "./PerformanceList.vue?vue&type=script&lang=ts&"
export * from "./PerformanceList.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceList.vue?vue&type=style&index=0&id=28b18b60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b18b60",
  null
  
)

export default component.exports